import axios from 'axios';
import { getLocalStorage, LogOut } from '../utils/helpers/helpers';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: getLocalStorage('access_token', true)
    ? {
        Authorization: `JWT ${getLocalStorage('access_token')}`,
      }
    : {},
});

// TODO: Better way to make ajaxTableRequests

const refresh = async (error) => {
  LogOut();
  return Promise.reject(error);
};

instance.interceptors.response.use(
  (value) => {
    return value;
  },
  async (error) => {
    try {
      const error_text = error.response.data.errors;

      if (error_text) {
        if (Array.isArray(error_text))
          for (const item of error_text) {
            if (item.detail === 'Token has expired.') await refresh(error);
          }
        else if (error_text.non_field_errors.includes('Token has expired.'))
          await refresh(error);
      }

      return Promise.reject(error);
    } catch (e) {
      return Promise.reject(error);
    }
  },
);

export default instance;
